// Friendly card display, used everywhere a card is shown to a human: last 4
// first, then the holder. Labels are stored as plain holder names ("Kyle"),
// so this only handles ordering and the no-label case.
export function formatCardLabel(card: { label: string; last4: string | null }): string {
  const name = (card.label || '').trim();
  // No label yet (an unmanaged card seen only on a statement) reads as a bare
  // "•• 8280", not the misleading "8280 - Card".
  if (!name) return card.last4 ? `•• ${card.last4}` : 'Card';
  return card.last4 ? `${card.last4} - ${name}` : name;
}
